export const translation = {
  notFound: "notFound",
  poweredBy: "poweredBy",
  clients: "clients",
  minutes: "minutes",
  totalMessage: "totalMessage",
  insideMessage: "insideMessage",
  waitingTimeMessage: "waitingTimeMessage",
};
